export default {
  bootstrapStatus: "idle",
  accessByCompany: {},
  selectedCompanyId: null,
  metadata: null,
  period: { from: null, to: null },
  filters: { legalEntityId: null, projectKey: null, costCenterId: null },
  receivableFilters: {
    customerRef: null,
    unitRef: null,
    basis: "nominal",
    page: 1,
    pageSize: 25,
  },
  // Estado da atualização (`GET /director/refresh-status`), da empresa selecionada.
  refreshStatus: null,
  refreshStatusError: null,
  cashflow: null,
  cashflowBreakdown: null,
  cashflowBreakdownError: null,
  itemVariances: null,
  customerReceipts: null,
  customerUnits: null,
  customerUnitsError: null,
  loading: {
    cashflow: false,
    cashflowBreakdown: false,
    itemVariances: false,
    customerReceipts: false,
    customerUnits: false,
  },
  error: null,
};
